const initialState = {
  publisher: {},
  serviceMeta: {},
  file: '',
};

// The deprecated licensing flow's actions are gone; licence-agreement-modal
// still reads this static slice (serviceMeta.serviceName, file).
const licensing = (state = initialState) => state;

export default licensing;
